import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import StyleOneSectionTitle from './StyleOneSectionTitle'
import { topicTeacherImgs } from '../../images/topicImg'

export class StyleOneIncreaseScore extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    itemsData: {}
  }
  componentWillMount() {
    this.setState({ itemsData: this.props.itemsData });
  }
  itemOnMouseEnter(id) {
    let { itemsData } = this.state;
    itemsData.list.map(item => {
      if (item.id === id) {
        item.active = true;
      } else {
        item.active = false;
      }
    })
    this.setState({ itemsData })
  }
  render() {
    let { itemsData } = this.state;
    return (
      <div className="topic-style-one-increase-score" style={{ background: `url(${itemsData.totalbackImg}) no-repeat`}}>
        <div className='increase_score_container'>
          <a name={itemsData.name}><StyleOneSectionTitle Data={itemsData} isColorW={false} /></a>
          <div className='increase_content_box flex_row'>
            {itemsData.list && itemsData.list.map(item => <div className={item.active ? 'increase_item active' : 'increase_item'} key={item.id} onMouseEnter={this.itemOnMouseEnter.bind(this, item.id)}>
              <div className='flex_row increase_titles'>
                <img src={topicTeacherImgs.scoring_left} alt="" />
                <div className='increase_item_title'>{item.title}</div>
                <img src={topicTeacherImgs.scoring_right} alt="" />
              </div>
              <div className='increase_image'>
                <div className='increase_item_numbers flex_row'>
                  <div className='increase_item_number'>{item.score}</div>
                  <div className='increase_item_point'>%</div>
                </div>
                <div className='increase_item_tips'>提分指数</div>
              </div>
              <div className='increase_item_stage'>
                <div className='stage_title flex_row'>{item.subtitle}</div>
                <div className='stage_list'>
                  {item.list && item.list.map(_item => <div className='stage_item flex_row' key={_item.id}>
                    <img src={_item.icon} alt="" />
                    <div className='stage_item_content'>{_item.content}</div>
                  </div>)}
                </div>
              </div>
            </div>)}
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleOneIncreaseScore);



// WEBPACK FOOTER //
// ./src/features/style-one/StyleOneIncreaseScore.js